import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound, Loader2, X } from "lucide-react";
import { API } from "./shared";

function ChangePasswordModal({ token, onClose }) {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 8) { setError("Nové heslo musí mať aspoň 8 znakov."); return; }
    if (newPassword !== confirm) { setError("Nové heslá sa nezhodujú."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`, { old_password: oldPassword, new_password: newPassword },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Heslo bolo úspešne zmenené.");
      onClose();
    } catch (err) {
      setError(err?.response?.data?.detail || "Zmena hesla zlyhala.");
    } finally { setLoading(false); }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4" data-testid="change-password-modal">
      <form onSubmit={submit} className="w-full max-w-sm bg-white text-navy rounded-2xl p-8 shadow-2xl relative">
        <button type="button" onClick={onClose} data-testid="change-password-close" className="absolute top-4 right-4 text-slate-400 hover:text-navy"><X className="w-5 h-5" /></button>
        <div className="flex items-center gap-2 mb-6"><KeyRound className="w-5 h-5 text-brand" /><h2 className="font-head text-xl font-semibold">Zmeniť heslo</h2></div>
        <label className="block text-sm font-medium mb-1">Súčasné heslo</label>
        <input data-testid="change-old-password" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} required className="w-full mb-4 px-4 py-2.5 rounded-md border border-navy/15 focus:outline-none focus:ring-2 focus:ring-brand" />
        <label className="block text-sm font-medium mb-1">Nové heslo</label>
        <input data-testid="change-new-password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required className="w-full mb-4 px-4 py-2.5 rounded-md border border-navy/15 focus:outline-none focus:ring-2 focus:ring-brand" />
        <label className="block text-sm font-medium mb-1">Zopakujte nové heslo</label>
        <input data-testid="change-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="w-full mb-2 px-4 py-2.5 rounded-md border border-navy/15 focus:outline-none focus:ring-2 focus:ring-brand" />
        <p className="text-xs text-slate-400 mb-4">Heslo musí mať aspoň 8 znakov.</p>
        {error && <p data-testid="change-password-error" className="text-sm text-red-600 mb-4">{error}</p>}
        <button data-testid="change-password-submit" disabled={loading} className="btn-lift w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover text-white font-semibold px-6 py-3 rounded-md disabled:opacity-60">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Uložiť nové heslo"}
        </button>
      </form>
    </div>
  );
}

export default function Settings({ token, email }) {
  const [showPw, setShowPw] = useState(false);
  return (
    <div data-testid="settings-panel">
      <h1 className="font-head text-2xl font-semibold mb-1">Nastavenia</h1>
      <p className="text-white/60 text-sm mb-8">Správa administrátorského účtu.</p>

      <div className="bg-white/5 border border-white/10 rounded-xl p-6 max-w-md">
        <h2 className="font-head text-lg font-semibold mb-4">Administrátorský účet</h2>
        <div className="flex items-center justify-between py-2 border-b border-white/5">
          <span className="text-white/60 text-sm">E-mail</span>
          <span className="text-sm">{email || "—"}</span>
        </div>
        <div className="flex items-center justify-between py-2">
          <span className="text-white/60 text-sm">Heslo</span>
          <button data-testid="settings-change-password" onClick={() => setShowPw(true)} className="inline-flex items-center gap-2 text-sm bg-brand hover:bg-brand-hover text-white font-medium px-4 py-2 rounded-md">
            <KeyRound className="w-4 h-4" /> Zmeniť heslo
          </button>
        </div>
      </div>

      {showPw && <ChangePasswordModal token={token} onClose={() => setShowPw(false)} />}
    </div>
  );
}
